import { render, staticRenderFns } from "./StatusResident.vue?vue&type=template&id=11ed3804&scoped=true&"
import script from "./StatusResident.vue?vue&type=script&lang=ts&"
export * from "./StatusResident.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ed3804",
  null
  
)

export default component.exports